module.exports = __webpack_public_path__ + "img/icone-pdf.4e7516b3.svg";